var render = function render(){var _vm=this,_c=_vm._self._c;return _c('star-rating',{attrs:{"read-only":"","increment":0.01,"fixed-points":2,"show-rating":false,"rating":_vm.rating,"inactive-color":"#000000","active-color":"#ffc100","star-size":15}})
}
var staticRenderFns = []

export { render, staticRenderFns }